/**
 * Age group calculation for volleyball (USA Volleyball standard)
 * Age is calculated as of July 1 of the current year.
 * @param {string} birthdate - ISO date string (e.g. "2008-03-15")
 * @returns {string} Age group (e.g. "14U", "18U")
 */
export function getAgeGroup(birthdate) {
  if (!birthdate) return null;
  const july1 = new Date(new Date().getFullYear(), 6, 1);
  const birth = new Date(birthdate);
  let age = july1.getFullYear() - birth.getFullYear();
  const monthDiff = july1.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && july1.getDate() < birth.getDate())) {
    age--;
  }
  const brackets = [10, 12, 14, 16, 18];
  for (const b of brackets) {
    if (age < b) return `${b}U`;
  }
  return '18U';
}

/** Legacy 5-bracket order (used by roster grouping) */
export const AGE_GROUP_ORDER = ['10U', '12U', '14U', '16U', '18U'];

/** Youth Volleyball age groups available for club setup (11U–18U) */
export const AVAILABLE_AGE_GROUPS = [
  '11U', '12U', '13U', '14U', '15U', '16U', '17U', '18U',
];

/**
 * Generate a deterministic team ID from age group and label.
 * e.g. ("14U", "1's") → "14u_1s"
 */
export function generateTeamId(ageGroup, label) {
  const ag = ageGroup.toLowerCase().replace(/\s+/g, '');
  const slug = label.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  return `${ag}_${slug}`;
}
